import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from '@arco-design/web-react';
import type { ColumnProps } from '@arco-design/web-react/es/Table';

import { resolveUsageScenarioLabel } from './constants';
import type { ServiceFormItem } from './types';
import { normalizeServiceList } from './utils';

interface ServicePortSummaryTableProps {
  services?: ServiceFormItem[] | Record<string, unknown>[] | null;
}

/** 确认页/详情摘要：服务端口列表表格展示 */
export function ServicePortSummaryTable({ services }: ServicePortSummaryTableProps) {
  const { t } = useTranslation();

  const columns = useMemo<ColumnProps<ServiceFormItem>[]>(
    () => [
      { title: t('data-center:maas.service.name'), dataIndex: 'name', width: 120 },
      {
        title: t('data-center:usage.scenario'),
        dataIndex: 'usageScenario',
        width: 160,
        render: (value: string) => resolveUsageScenarioLabel(value),
      },
      { title: t('common:internal.port'), dataIndex: 'internalPort', width: 100 },
      { title: t('common:path'), dataIndex: 'routerPath', width: 140, render: (v) => v || '-' },
      { title: t('common:description'), dataIndex: 'description', width: 140, render: (v) => v || '-' },
      {
        title: t('common:external.port'),
        dataIndex: 'externalPort',
        width: 100,
        render: (value: number) => (value ? value : t('common:auto.assign')),
      },
    ],
    [t],
  );

  const data = useMemo(() => {
    const list = normalizeServiceList(services);
    return list.map((item, index) => ({ ...item, key: String(index) }));
  }, [services]);

  if (!data.length) {
    return <>-</>;
  }

  return <Table columns={columns} data={data} pagination={false} border={{ wrapper: true, cell: true }} size="small" />;
}
